import {
  AbsencePeriodsController,
  AccountantController,
  AccountantWizardController,
  AccountingChannelSettingsController,
  AccountAuthorizationController,
  AccountingHolidayPayDebtReportQueryController,
  AccountingReportCrudController,
  AccountingReportDisplayController,
  AccountingReportQueryController,
  AccountingReportRowsController,
  AccountingReportToolsController,
  AccountingRowReportController,
  AccountingTargetCrudController,
  AccountResetController,
  ActionButtonController,
  AlertController,
  AvatarController,
  BatchProcessController,
  CalcChartController,
  CalcCostAccountingController,
  CalcEmploymentController,
  CalcHouseholdUsecaseController,
  CalcImportController,
  CalcIrRowsController,
  CalcsIrRowsController,
  CalcRepairController,
  CalcRepairInfoController,
  CalcReportController,
  CalcReportsController,
  CalcReportsDisplayController,
  CalcRowCostAccountingController,
  CalcRowDimensionInputController,
  CalcRowDocumentationController,
  CalcRowFormulaController,
  CalcRowTypeController,
  CalcRows2019Controller,
  CalcSharingController,
  CalcSharingReceiptActionController,
  CalculationCrudController,
  CalculationEditorController,
  CalculationReportController,
  Calculator2019Controller,
  Calculator2022Controller,
  CalcWorktimeController,
  CalendarController,
  CalendarEventsCrudController,
  CertificateController,
  ChartController,
  CompanyAccountController,
  CompanyInvoicesController,
  CompanyImportController,
  CompanyOnboardingController,
  CompanySettingsController,
  ContactInfoController,
  CostAccountingController,
  CredentialController,
  CreditTransferController,
  CustomerInvoiceCrudController,
  CustomerOnboardingController,
  DatasetsCrudController,
  DatepickerController,
  DatepickerPopupController,
  DateRangeController,
  EditDialogController,
  EmbeddedUiController,
  EmployerListController,
  EmployerReportController,
  EmployerSelectController,
  EmploymentCrudController,
  EmploymentTaxcardsController,
  EmploymentWizardController,
  ExportController,
  HolidayPayReportQueryController,
  HolidayReportController,
  HolidayYearAccrualController,
  HolidayYearCrudController,
  HolidayYearHolidaysController,
  HolidayYearPaidController,
  HouseholdDeductionReportController,
  HouseholdOnboardingController,
  HouseholdYearCrudController,
  ImportController,
  ImportStagingController,
  InputBooleanController,
  InputCollectiveBargainAgreementController,
  InputCredentialController,
  InputDurationController,
  InputEmployeeGroupController,
  InputEnumController,
  InputHolidayMultipliersController,
  InputPayStatsRowTypeController,
  InputIncomeTypeController,
  InputNumberController,
  InputRruleController,
  InputTimeController,
  InputTypeaheadController,
  InsuranceWizardController,
  InvoiceCrudController,
  InvoicesCreateController,
  InvoiceReportController,
  InvoiceSepaController,
  InvoiceToolsController,
  InvoiceAlertsController,
  InvoicePaymentListController,
  IrEarningsPaymentCrudController,
  IrPayerSummaryCrudController,
  JsonFormatterController,
  JsonDiffController,
  MarkdownEditorController,
  MarkdownViewerController,
  MessageThreadCrudController,
  ModalGenericDialogController,
  MyTaxcardsController,
  NaviController,
  NewPaymentController,
  ODataActionsController,
  ODataHelperController,
  ODataQueryController,
  OmapalkkaController,
  OwnerSettingsController,
  PartnerController,
  PayCertificateController,
  PaymentChannelController,
  PaymentController,
  PaymentChannelSettingsController,
  PayrollCrudController,
  Payroll4AssistantController,
  Payroll4CrudController,
  PayStatsReportQueryController,
  PalkkausPersonalPaymentOverviewController,
  PersonAccountController,
  RecordsController,
  ReferenceObjectCrudController,
  ReportsController,
  RowTypesSettingsController,
  SalaryBasesController,
  SalaryDateKindController,
  SalarySlipDownloadController,
  SalaryReportCrudController,
  SessionController,
  SignatureController,
  ServiceModelCrudController,
  SigningController,
  SmokeTestController,
  SpinnerController,
  SxyCodeEditorController,
  SxyFormController,
  SxyFormElementController,
  SxyTableController,
  SxyGridController,
  SxyInputController,
  SxySchemaEditorController,
  TabController,
  TabsController,
  TabButtonsController,
  TaxcardManualEditController,
  TaxcardCrudController,
  TaxcardIncomeLogController,
  TemplateCrudController,
  ToggleButtonsController,
  UiTranslatorController,
  UsecasesCrudController,
  VarmaBannerController,
  WelcomeController,
  WizardController,
  WorkerAbsencesCrudController,
  WorkerAccountCrudController,
  WorkerAssureController,
  WorkerExpenseReportController,
  WorkerHourlyReportController,
  WorkerImportController,
  WorkerOnboardingController,
  WorkerReportController,
  WorkerSummaryReportController,
  WorkerSummaryReportDisplayController,
  WorkerTimerController,
  WorkflowController,
  WorkflowBadgeController,
  SummaryReportDisplayController,
  SummaryReportController,
  SummaryReportQueryController,
  TimesheetWorkerDemoController,
  ValidationSummaryController
} from ".";
import { CalcLeavesController } from "./calc/CalcLeavesController";

/**
 * Provides methods for registering the Controllers to module
 * (and other related metadata in the future).
 */
export class ControllersRegistration {

  /** Gets the controllers for Module registration. */
  public static getControllers () {
    return {
      AbsencePeriodsController,
      AccountantController,
      AccountantWizardController,
      AccountingChannelSettingsController,
      AccountAuthorizationController,
      AccountingHolidayPayDebtReportQueryController,
      AccountingReportCrudController,
      AccountingReportDisplayController,
      AccountingReportQueryController,
      AccountingReportRowsController,
      AccountingReportToolsController,
      AccountingRowReportController,
      AccountingTargetCrudController,
      AccountResetController,
      ActionButtonController,
      AlertController,
      AvatarController,
      BatchProcessController,
      CalcChartController,
      CalcCostAccountingController,
      CalcEmploymentController,
      CalcHouseholdUsecaseController,
      CalcImportController,
      CalcIrRowsController,
      CalcsIrRowsController,
      CalcWorktimeController,
      CalcRepairController,
      CalcRepairInfoController,
      CalcReportController,
      CalcReportsController,
      CalcReportsDisplayController,
      CalcRowCostAccountingController,
      CalcRowDimensionInputController,
      CalcRowDocumentationController,
      CalcRowFormulaController,
      CalcRowTypeController,
      CalcRows2019Controller,
      CalcSharingController,
      CalcSharingReceiptActionController,
      CalculationCrudController,
      CalculationEditorController,
      CalculationReportController,
      Calculator2019Controller,
      Calculator2022Controller,
      CalcLeavesController,
      CalendarController,
      CalendarEventsCrudController,
      CertificateController,
      ChartController,
      CompanyAccountController,
      CompanyInvoicesController,
      CompanyImportController,
      CompanyOnboardingController,
      CompanySettingsController,
      ContactInfoController,
      CostAccountingController,
      CredentialController,
      CreditTransferController,
      CustomerInvoiceCrudController,
      CustomerOnboardingController,
      DatasetsCrudController,
      DatepickerController,
      DatepickerPopupController,
      DateRangeController,
      EditDialogController,
      EmbeddedUiController,
      EmployerListController,
      EmployerReportController,
      EmployerSelectController,
      EmploymentCrudController,
      EmploymentTaxcardsController,
      EmploymentWizardController,
      ExportController,
      HolidayPayReportQueryController,
      HolidayReportController,
      HolidayYearAccrualController,
      HolidayYearCrudController,
      HolidayYearHolidaysController,
      HolidayYearPaidController,
      HouseholdDeductionReportController,
      HouseholdOnboardingController,
      HouseholdYearCrudController,
      ImportController,
      ImportStagingController,
      InputBooleanController,
      InputCollectiveBargainAgreementController,
      InputCredentialController,
      InputDurationController,
      InputEmployeeGroupController,
      InputEnumController,
      InputHolidayMultipliersController,
      InputPayStatsRowTypeController,
      InputIncomeTypeController,
      InputNumberController,
      InputRruleController,
      InputTimeController,
      InputTypeaheadController,
      InsuranceWizardController,
      InvoiceCrudController,
      InvoicesCreateController,
      InvoiceReportController,
      InvoiceSepaController,
      InvoiceToolsController,
      InvoiceAlertsController,
      InvoicePaymentListController,
      IrEarningsPaymentCrudController,
      IrPayerSummaryCrudController,
      JsonFormatterController,
      JsonDiffController,
      MarkdownEditorController,
      MarkdownViewerController,
      MessageThreadCrudController,
      ModalGenericDialogController,
      MyTaxcardsController,
      NaviController,
      NewPaymentController,
      ODataActionsController,
      ODataHelperController,
      ODataQueryController,
      OmapalkkaController,
      OwnerSettingsController,
      PartnerController,
      PayCertificateController,
      PaymentController,
      PaymentChannelController,
      PaymentChannelSettingsController,
      PayrollCrudController,
      Payroll4AssistantController,
      Payroll4CrudController,
      PayStatsReportQueryController,
      PalkkausPersonalPaymentOverviewController,
      PersonAccountController,
      RecordsController,
      ReferenceObjectCrudController,
      ReportsController,
      RowTypesSettingsController,
      SalaryBasesController,
      SalaryDateKindController,
      SalarySlipDownloadController,
      SalaryReportCrudController,
      SessionController,
      ServiceModelCrudController,
      SignatureController,
      SigningController,
      SmokeTestController,
      SpinnerController,
      SummaryReportController,
      SummaryReportDisplayController,
      SummaryReportQueryController,
      SxyCodeEditorController,
      SxyFormController,
      SxyFormElementController,
      SxyTableController,
      SxyGridController,
      SxyInputController,
      SxySchemaEditorController,
      TabController,
      TabsController,
      TabButtonsController,
      TaxcardManualEditController,
      TaxcardCrudController,
      TaxcardIncomeLogController,
      TemplateCrudController,
      ToggleButtonsController,
      UiTranslatorController,
      UsecasesCrudController,
      VarmaBannerController,
      WelcomeController,
      WizardController,
      WorkerAbsencesCrudController,
      WorkerAccountCrudController,
      WorkerAssureController,
      WorkerExpenseReportController,
      WorkerHourlyReportController,
      WorkerImportController,
      WorkerOnboardingController,
      WorkerReportController,
      WorkerSummaryReportController,
      WorkerSummaryReportDisplayController,
      WorkerTimerController,
      WorkflowController,
      WorkflowBadgeController,
      TimesheetWorkerDemoController,
      ValidationSummaryController
    };
  }
}
